module.exports = __webpack_public_path__ + "static/media/BackwardArrow.f2f751d3.svg";